export function counterArray(n: number) {
  const arr: Array<number> = [];
  for (let i = 1; i <= n; i++) {
    arr.push(i);
  }
  return arr;
}
